import { createStore } from 'state-pool'

const store = createStore()

export default store
